export default __webpack_public_path__ + "static/media/Java_Icon.5d5cffa0.png";